import { Spinner, Theme, ThemeProvider } from "@afterpaytouch/core";
import classNames from "classnames";
import { useTranslation } from "next-i18next";
import React from "react";

import { useInAppDarkMode } from "@/hooks/useInAppDarkMode";

import styles from "./gift-card-placing-order.module.scss";

/*
 * Full-screen loading state for the in-app gift card checkout webview.
 * Rendered identically in every locale (the webview is the same surface
 * everywhere): the AP theme is forced around the Spinner so en-US (Cash
 * theme) gets the same plain spinner, and the header/message styles are
 * nested under the container so they win over the global .arcade heading
 * styles that the en-US layout applies.
 */
export const GiftCardPlacingOrder: React.FC = () => {
    const { t } = useTranslation();
    const isDark = useInAppDarkMode();

    return (
        <div className={classNames(styles.container, { [styles.dark]: isDark })}>
            <div className={styles.spinner}>
                <ThemeProvider theme={Theme.AP}>
                    <Spinner />
                </ThemeProvider>
            </div>
            <h2 className={styles.header}>{t("giftCards.placingOrder.header")}</h2>
            <p className={styles.message}>{t("giftCards.placingOrder.message")}</p>
        </div>
    );
};
